import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { withTranslation } from 'react-i18next'
import withRouter from '../../../../components/Common/withRouter'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useParams } from 'react-router-dom';
import { createSelector } from 'reselect';
import TableWitthoutPagination from '../../../../components/Common/TableWitthoutPagination';
import { deleteBonusSetting, loadBonusSettings } from '../../../../slice/thunks';
import AddOrEditBonusSetting from './utilities/AddOrEditBonusSetting';
import DeleteBonusSetting from './utilities/DeleteBonusSetting';

function BonusSettings(props) {
    const dispatch = useDispatch()
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [openAddOrEditModal, setOpenAddOrEditModal] = useState(false);
    const [bonusSettingToDelete, setBonusSettingToDelete] = useState(null);
    const location = useLocation();
    const name = new URLSearchParams(location.search).get('name');

    const { id } = useParams();


    const selectLayoutState = (state) => state.Payroll;
    const PayrollProperties = createSelector(
        selectLayoutState,
        (payroll) => ({
            bonusSettings: payroll?.bonusSettings ?? [],
            error: payroll?.error ?? null
        })
    )

    const { bonusSettings, } = useSelector(PayrollProperties)
    const [bonusSettingToEdit, setBonusSettingToEdit] = useState(null);

const onloadBonusSettings = useCallback(() => {
    const action = loadBonusSettings({ id });
    console.log("ACTION:", action);
    dispatch(action);
}, [dispatch, id]);

    // const onloadBonus = useCallback(() => {
    //     dispatch(loadBonusSetting({ id }))
    // }, [dispatch, id]);

    const handleDeleteClickEvent = useCallback((row) => {
        setBonusSettingToDelete(row);
        setOpenDeleteModal(true);
    }, [setOpenDeleteModal, setBonusSettingToDelete]);

    const handleEditClick = useCallback((row) => {
        setBonusSettingToEdit(row);
        setOpenAddOrEditModal(true);

    }, []);

    const fermerModal = useCallback(() => {
        setOpenDeleteModal(false);
    }, [setOpenDeleteModal]);

    const AddOrEditCloseModal = useCallback(() => {
        setOpenAddOrEditModal(false);
    }, [setOpenAddOrEditModal])

    const handleToggle = () => {
        setOpenDeleteModal(!openDeleteModal);
    }

    const handleAddOrEditToggle = () => {
        setOpenAddOrEditModal(true);
        setBonusSettingToEdit(null);
    }

    const confirmDelete = useCallback(() => {
        dispatch(deleteBonusSetting({
            bonusId: id,
            id: bonusSettingToDelete.id
        }));
        setOpenDeleteModal(false);
    }, [dispatch, id, bonusSettingToDelete])

useEffect(() => {
    onloadBonusSettings();
}, [onloadBonusSettings])

    const columns = useMemo(() => [
        {
            id: 'rank',
            header: 'Rank',
            accessorKey: "rank",
        },
        {
            id: 'salary-min',
            header: 'Salary Min',
            accessorKey: "salaryMin",
        },
        {
            id: 'salary-max',
            header: 'Salary Max',
            accessorKey: "salaryMax",
        },
        {
            id: 'rate-amount',
            header: 'Rate / Amount',
            cell: (cellProp) => {
                return (
                    <>
                        {cellProp.row.original.percentage ? cellProp.row.original.rateOrAmount + ' %' : cellProp.row.original.rateOrAmount}
                    </>
                )
            }
        },
        {
            id: 'actions',
            header: 'Actions',
            cell: (cellProp) => {
                return (
                    <>
                        <div className="text-center">
                            <Link onClick={() => handleEditClick(cellProp.row.original)} type="button">
                                <i className="fa-solid fa-pencil"></i>
                            </Link>
                            <Link type="button" onClick={() => handleDeleteClickEvent(cellProp.row.original)}>
                                <i className="ms-1 fa-solid fa-trash"></i>
                            </Link>
                        </div>
                    </>
                );
            }
        },
    ]);

    return (
        <div className="setting-zone-screen-13-2-sec">
            <div className="container">
                <div className="id g-4 pt-4 px-4 mb-3">
                    <div className="head d-flex">
                        <h6>Bonus : {name ?? ''}</h6>
                    </div>
                    <div className="setting-zone-screen-13-2 d-flex" style={{ "height:": "fit-content" }}>
                        <div className="zone-13-2-sec d-flex">
                            <div className="col d-flex align-items-center">
                                <div className="arrow-left mt-2">
                                    <Link to={"/payroll/setting/bonus"}>
                                        <i class="fa fa-arrow-left" aria-hidden="true" style={{ "font-size": "20px" }}></i>
                                    </Link>
                                </div>
                                <div className="heading align-middle">
                                    <p className="mb-0">Back to Bonus List</p>
                                </div>
                            </div>

                            <div className="col d-flex justify-content-end text-end">
                                <button className="btn btn-std mx-2" onClick={() => handleAddOrEditToggle()}>
                                    New config
                                </button>
                            </div>
                        </div>
                        <TableWitthoutPagination
                            columns={columns}
                            data={bonusSettings}
                        />
                        <AddOrEditBonusSetting
                            openModal={openAddOrEditModal}
                            handleToggle={handleAddOrEditToggle}
                            AddOrEditCloseModal={AddOrEditCloseModal}
                            bonusSetting={bonusSettingToEdit}
                            bonusId={id}
                        />
                        <DeleteBonusSetting
                            open={openDeleteModal}
                            handleToggle={handleToggle}
                            clickActionCallback={confirmDelete}
                            fermerModal={fermerModal}
                        />

                    </div>
                </div>
            </div>

        </div>
    );
};

export default withRouter(withTranslation()(BonusSettings))